/*
 * Dave Tech: sticky Add to cart bar for phones and tablets (see dt-mobile-product.css).
 * Shows the product's price and an Add to cart button whenever the real button is off screen. Tapping it
 * clicks the real button, so the theme's own add-to-cart request, cart notification and error handling run.
 * Mirrors the real button's text and disabled state (e.g. "Sold out"), and the price if it changes.
 */
(() => {
  if (document.querySelector(".dt-sticky-atc")) return; // already set up (never two bars)
  const MOBILE = window.matchMedia("(max-width: 989px)");
  const form = document.querySelector("product-form form[action*='/cart/add']");
  const realButton = form && form.querySelector("button[type='submit'], button[name='add']");
  const info = form && form.closest(".product__info-container");
  if (!form || !realButton || !info) return;

  const priceEl = info.querySelector(".price");
  const titleEl = info.querySelector(".product__title h1") || info.querySelector("h1");
  const vatEl = info.querySelector(".dt-vat-status--product");

  const bar = document.createElement("div");
  // "product-form__buttons" marks the bar as a purchase control for dt-floating-widgets.js, which then hides
  // the chat and rewards buttons while they would overlap it.
  bar.className = "dt-sticky-atc product-form__buttons";
  bar.setAttribute("data-visible", "false");
  bar.setAttribute("aria-hidden", "true");
  bar.innerHTML =
    '<div class="dt-sticky-atc__info">' +
    '<span class="dt-sticky-atc__title"></span>' +
    '<span class="dt-sticky-atc__price"><span class="dt-sticky-atc__amount"></span><s class="dt-sticky-atc__compare" hidden></s><span class="dt-sticky-atc__vat"></span></span>' +
    "</div>" +
    '<button type="button" class="dt-sticky-atc__button"></button>';
  document.body.appendChild(bar);
  const amountEl = bar.querySelector(".dt-sticky-atc__amount");
  const compareEl = bar.querySelector(".dt-sticky-atc__compare");
  const vatOut = bar.querySelector(".dt-sticky-atc__vat");
  const titleOut = bar.querySelector(".dt-sticky-atc__title");
  const button = bar.querySelector(".dt-sticky-atc__button");

  // innerText skips parts hidden with CSS (e.g. whichever of "ex VAT" / "inc VAT" is not showing)
  const text = (el) => (el ? (el.innerText || el.textContent).replace(/\s+/g, " ").trim() : "");
  function sync() {
    titleOut.textContent = text(titleEl);
    if (priceEl) {
      const onSale = priceEl.classList.contains("price--on-sale");
      const sale = priceEl.querySelector(".price__sale .price-item--sale");
      const regular = priceEl.querySelector(".price__regular .price-item--regular");
      const was = priceEl.querySelector(".price__sale .price-item--regular");
      amountEl.textContent = text(onSale && sale ? sale : regular || sale);
      const wasText = onSale ? text(was) : "";
      compareEl.textContent = wasText;
      compareEl.hidden = !wasText;
    }
    vatOut.textContent = text(vatEl);
    const label = text(realButton.querySelector("span") || realButton);
    button.textContent = label || "Add to cart";
    button.disabled = realButton.disabled || realButton.getAttribute("aria-disabled") === "true";
    button.setAttribute("aria-busy", realButton.getAttribute("aria-busy") === "true" ? "true" : "false");
  }
  sync();
  new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ["disabled", "aria-disabled", "aria-busy", "class"] });

  button.addEventListener("click", () => {
    if (button.disabled) return;
    realButton.click();
  });

  // Visible while the real button is off screen (above or below), on mobile widths only.
  let buttonInView = true;
  const measure = () => document.body.style.setProperty("--dt-sticky-atc-h", `${Math.round(bar.getBoundingClientRect().height)}px`);
  // dt-floating-widgets.js rechecks for overlaps on scroll; ask it again once the bar has slid in or out.
  const nudgeWidgets = () => window.dispatchEvent(new Event("scroll"));
  bar.addEventListener("transitionend", nudgeWidgets);
  const render = () => {
    const show = MOBILE.matches && !buttonInView && window.scrollY > 10;
    const changed = bar.getAttribute("data-visible") !== String(show);
    bar.setAttribute("data-visible", show ? "true" : "false");
    bar.setAttribute("aria-hidden", show ? "false" : "true");
    document.body.classList.toggle("dt-sticky-atc-visible", show);
    if (show) measure();
    if (changed) setTimeout(nudgeWidgets, 250);
  };
  if ("IntersectionObserver" in window) {
    new IntersectionObserver((entries) => { buttonInView = entries[0].isIntersecting; render(); }, { threshold: 0.25 }).observe(realButton);
  } else {
    const check = () => { const r = realButton.getBoundingClientRect(); buttonInView = r.bottom > 0 && r.top < window.innerHeight; render(); };
    window.addEventListener("scroll", check, { passive: true }); check();
  }
  window.addEventListener("scroll", render, { passive: true });
  window.addEventListener("resize", render, { passive: true });
  MOBILE.addEventListener ? MOBILE.addEventListener("change", render) : MOBILE.addListener(render);
  measure();
})();
